import styles from "./Bonuses.module.scss";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Light from "../../imgs/light.svg";

export default function Bonuses() {
  const { t } = useTranslation();

  return (
    <div className={styles.page}>
      <Header />
      <div className={styles.header}>
        <img className={styles.light} src={Light} />
        <h1>{t("Trade easily and confidently")}</h1>
      </div>

      <div className={styles.container}>
        <div className={styles.info_container}>
          <div className={styles.info}>
            <h1>
              {t(
                "Choose the appropriate option and increase your profit without leaving home!"
              )}
            </h1>
            <p>
              {t(
                "See for yourself! We offer new clients a 7-day insurance and the opportunity to test passive earnings with our Trade-Bot."
              )}
            </p>
          </div>
          <div className={styles.blocks}>
            <div className={styles.block}>
              <div className={styles.last_block}>
                <span className={styles.title}>{t("Exchange trading")}</span>
                <div className={styles.blocks__background_orange}>
                  <span className={styles.blocks__orange_info}>
                    {t(
                      "You have access to bonuses, personal advisor services and 0% commission."
                    )}
                  </span>
                </div>
                <ul className={styles.list}>
                  {t("Select an asset:")}
                  <li>
                    <label className={styles.custom_checkbox}>
                      <input type="radio" name="1" />
                      <span className={styles.checkmark}></span>
                    </label>
                    <span>{t("Oil, gas, gold and other raw materials")}</span>
                  </li>
                  <li>
                    <label className={styles.custom_checkbox}>
                      <input type="radio" name="1" />
                      <span className={styles.checkmark}></span>
                    </label>
                    <span>{t("Shares and indices of world companies")}</span>
                  </li>
                  <li>
                    <label className={styles.custom_checkbox}>
                      <input type="radio" name="1" />
                      <span className={styles.checkmark}></span>
                    </label>
                    <span>{t("Cryptocurrency")}</span>
                  </li>
                </ul>
              </div>
              <Link to="/cabinet" className={styles.button}>
                {t("Sign up")}<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M4 12L12 4M12 4L12 10M12 4L6 4" stroke="white" stroke-width="1.5" stroke-linecap="square"/>
</svg>
              </Link>
            </div>
            <div className={styles.block}>
              <div className={styles.last_block}>
                <span className={styles.title}>{t("Currency exchange")}</span>
                <div className={styles.blocks__background_green}>
                  <span className={styles.blocks__green_info}>
                    {t("We change at the pre-crisis rate!")}
                  </span>
                </div>
                <ul className={styles.list}>
                  {t("Select the amount and find out the rate:")}
                  <li>
                    <label className={styles.custom_checkbox}>
                      <input type="radio" name="2" />
                      <span className={styles.checkmark}></span>
                    </label>
                    <span>{t("From 30,000 to 80,000 $")}</span>
                  </li>
                  <li>
                    <label className={styles.custom_checkbox}>
                      <input type="radio" name="2" />
                      <span className={styles.checkmark}></span>
                    </label>
                    <span>{t("From $81,000 to $200,000")}</span>
                  </li>
                  <li>
                    <label className={styles.custom_checkbox}>
                      <input type="radio" name="2" />
                      <span className={styles.checkmark}></span>
                    </label>
                    <span>{t("From $200,000 to $1,000,000")}</span>
                  </li>
                </ul>
              </div>
              <Link to="/cabinet" className={styles.button}>
                {t("Sign up")}<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M4 12L12 4M12 4L12 10M12 4L6 4" stroke="white" stroke-width="1.5" stroke-linecap="square"/>
</svg>
              </Link>
            </div>
            <div className={styles.block}>
              <div className={styles.last_block}>
                <span className={styles.title}>{t("Investments")}</span>
                <div className={styles.blocks__background_blue}>
                  <span className={styles.blocks__blue_info}>
                    {t("Rate 5% per month until December 2024")}
                  </span>
                </div>
                <ul className={styles.list}>
                  {t("Select the appropriate option:")}
                  <li>
                    <label className={styles.custom_checkbox}>
                      <input type="radio" name="3" />
                      <span className={styles.checkmark}></span>
                    </label>
                    <span>
                      {t("With the ability to withdraw interest monthly")}
                    </span>
                  </li>
                  <li>
                    <label className={styles.custom_checkbox}>
                      <input type="radio" name="3" />
                      <span className={styles.checkmark}></span>
                    </label>
                    <span>
                      {t("Without the ability to withdraw interest monthly")}
                    </span>
                  </li>
                </ul>
              </div>
              <Link to="/cabinet" className={styles.button}>
                {t("Sign up")}<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M4 12L12 4M12 4L12 10M12 4L6 4" stroke="white" stroke-width="1.5" stroke-linecap="square"/>
</svg>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
